import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { createEmployee } from 'src/app/store/actions/admin.action';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';
import { MustMatch } from 'src/app/validators/mustmatch.validator';

@Component({
  selector: 'app-create-employee',
  templateUrl: './create-employee.component.html',
  styleUrls: ['./create-employee.component.scss']
})
export class CreateEmployeeComponent implements OnInit {

  form: FormGroup;
  emailPattern = /^([a-z0-9_\.\+-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;

  showPassword = false;
  showConfirm = false;

  constructor(
    private modalService: ModalService,
    private fb: FormBuilder,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      first_name: ['', [Validators.required]],
      middle_name: ['', new FormControl()],
      last_name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      access_name: ['', [Validators.required]],
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      password_confirmation: ['', [Validators.required]],
    }, {
      validator: MustMatch('password', 'password_confirmation')
    })
  }

  submit(){
    const payload = {
      first_name: this.first_name?.value,
      middle_name: this.middle_name?.value,
      last_name: this.last_name?.value,
      email: this.email?.value,
      access_name: this.access_name?.value,
      username: this.username?.value,
      password: this.password?.value,
      password_confirmation: this.password_confirmation?.value,
    }

    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(createEmployee({data: payload}));
  }

  get first_name(){
    return this.form.get('first_name');
  }

  get middle_name(){
    return this.form.get('middle_name');
  }

  get last_name(){
    return this.form.get('last_name');
  }

  get email(){
    return this.form.get('email');
  }

  get access_name(){
    return this.form.get('access_name');
  }

  get username(){
    return this.form.get('username');
  }

  get password(){
    return this.form.get('password');
  }

  get password_confirmation(){
    return this.form.get('password_confirmation');
  }

  dismiss(){
    this.modalService.hideCreateEmployee();
  }

  togglePassword(){
    this.showPassword =!this.showPassword;
  }

  toggleConfirm(){
    this.showConfirm =!this.showConfirm;
  }

}
